import { PAYMENT_STATUSES } from '@equidefi/constants/payments';
export { PAYMENTS_CHANGE_METHOD_STATUSES, PAYMENT_FAILED_STATUSES, PAYMENT_PENDING_STATUSES, PAYMENT_STATUSES, PAYMENT_STRIKETHROUGH_AMOUNT_STATUSES } from '@equidefi/constants/payments';

// constants/payments.ts
var MAXIMUM_STRIPE_AMOUNT = 11e4;
var PAYMENT_TYPES = {
  CARD: "card",
  CHECK: "check",
  WIRE: "wire",
  CRYPTO: "crypto",
  US_BANK_ACCOUNT: "us_bank_account",
  STRIPE_WIRE: "customer_balance",
  CASHAPP: "cashapp"
};
var PROCESSING_FEE_RATES = {
  card: { percent: 0.029, fixed: 0.3 },
  cashapp: { percent: 0.029, fixed: 0.3 },
  link: { percent: 0.029, fixed: 0.3 },
  apple_pay: { percent: 0.029, fixed: 0.3 },
  google_pay: { percent: 0.029, fixed: 0.3 },
  us_bank_account: { percent: 8e-3, fixed: 0, cap: 5 },
  customer_balance: { percent: 8e-3, fixed: 0, cap: 5 },
  crypto: { percent: 0.01, fixed: 0 }
  // BVNK merchant fee (1%)
};
var PAYMENT_STATUS_DISPLAY = {
  created: {
    title: "Pending",
    color: "yellow",
    status: "pending"
  },
  processing: {
    title: "Processing",
    color: "yellow",
    status: "pending"
  },
  underpaid: {
    title: "Underpaid",
    color: "red",
    status: "error"
  },
  detected: {
    title: "Detected",
    color: "yellow",
    status: "pending"
  },
  payment_failed: {
    title: "Failed",
    color: "red",
    status: "error"
  },
  requires_payment_method: {
    title: "Missing Payment Method",
    color: "red",
    status: "error"
  },
  requires_action: {
    title: "Requires Action",
    color: "yellow",
    status: "pending"
  },
  succeeded: {
    title: "Succeeded",
    color: "green",
    status: "success"
  },
  refunded: {
    title: "Refunded",
    color: "red",
    status: "error"
  },
  canceled: {
    title: "Canceled",
    color: "red",
    status: "error"
  },
  requires_capture: {
    title: "Authorized",
    color: "blue",
    status: "info"
  },
  expired: {
    title: "Authorization Expired",
    color: "red",
    status: "error"
  }
};
var PAYMENT_TYPE_OPTIONS = [
  { label: "Card", value: PAYMENT_TYPES.CARD },
  { label: "Check", value: PAYMENT_TYPES.CHECK },
  { label: "Wire", value: PAYMENT_TYPES.WIRE },
  { label: "Crypto", value: PAYMENT_TYPES.CRYPTO },
  { label: "ACH", value: PAYMENT_TYPES.US_BANK_ACCOUNT },
  { label: "CashApp", value: PAYMENT_TYPES.CASHAPP }
];
var PAYMENT_METHOD_LABEL_BY_TYPE = {
  [PAYMENT_TYPES.CARD]: "Card",
  [PAYMENT_TYPES.CHECK]: "Check",
  [PAYMENT_TYPES.WIRE]: "Wire",
  [PAYMENT_TYPES.CRYPTO]: "Crypto",
  [PAYMENT_TYPES.US_BANK_ACCOUNT]: "ACH",
  [PAYMENT_TYPES.CASHAPP]: "CashApp",
  [PAYMENT_TYPES.STRIPE_WIRE]: "Wire"
};
var PAYMENT_STATUS_OPTIONS = [
  { label: "Succeeded", value: PAYMENT_STATUSES.SUCCEEDED },
  { label: "Created", value: PAYMENT_STATUSES.CREATED },
  { label: "Detected", value: PAYMENT_STATUSES.DETECTED },
  { label: "Underpaid", value: PAYMENT_STATUSES.UNDERPAID },
  { label: "Requires Capture", value: PAYMENT_STATUSES.REQUIRES_CAPTURE },
  { label: "Requires Action", value: PAYMENT_STATUSES.REQUIRES_ACTION },
  {
    label: "Requires Payment Method",
    value: PAYMENT_STATUSES.REQUIRES_PAYMENT_METHOD
  },
  { label: "Canceled", value: PAYMENT_STATUSES.CANCELED },
  { label: "Refunded", value: PAYMENT_STATUSES.REFUNDED }
];

export { MAXIMUM_STRIPE_AMOUNT, PAYMENT_METHOD_LABEL_BY_TYPE, PAYMENT_STATUS_DISPLAY, PAYMENT_STATUS_OPTIONS, PAYMENT_TYPES, PAYMENT_TYPE_OPTIONS, PROCESSING_FEE_RATES };
